import styled from 'styled-components';
export var FieldGroup = styled.div.withConfig({
  displayName: "FieldGroup",
  componentId: "keen-widget-settings__d91bcb-0"
})(["&&&{display:flex;align-items:center;justify-content:space-between;margin-bottom:20px;}"]);